module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/apprenticePointingDiagonal-01628f9248ed94db92bf66a6d3f2ca75.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/apprenticePointingDiagonal.png
// module id = 906
// module chunks = 2